<script setup>

</script>

<template>

  <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="5.71613" r="4.49286" stroke="#333333" stroke-width="1.01429"/>
    <path d="M5.10938 3.39987V5.89599L6.78217 7.35207" stroke="#333333" stroke-width="1.01429" stroke-linecap="round"/>
  </svg>



</template>

<style scoped lang="scss">

</style>